/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string } from 'prop-types';

const RecentIcon = ({ fillColor }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 5.24609C12.4142 5.24609 12.75 5.58188 12.75 5.99609L12.75 11.5326L16.3354 13.3253C16.7059 13.5105 16.8561 13.961 16.6708 14.3315C16.4856 14.702 16.0351 14.8522 15.6646 14.6669L11.6646 12.6669C11.4105 12.5399 11.25 12.2802 11.25 11.9961L11.25 5.99609C11.25 5.58188 11.5858 5.24609 12 5.24609Z"
            fill={fillColor}
        />
        <path
            d="M7.66925 5.52026L6.57426 4.42523C8.10255 3.32848 9.97592 2.68333 12 2.68333C17.1455 2.68333 21.3167 6.85455 21.3167 12C21.3167 17.1455 17.1455 21.3167 12 21.3167C6.85455 21.3167 2.68333 17.1455 2.68333 12C2.68333 11.6042 2.36247 11.2833 1.96667 11.2833C1.57086 11.2833 1.25 11.6042 1.25 12C1.25 17.937 6.06295 22.75 12 22.75C17.937 22.75 22.75 17.937 22.75 12C22.75 6.06295 17.937 1.25 12 1.25C9.57935 1.25 7.34557 2.05042 5.54907 3.40005L4.44425 2.29525C4.23929 2.09029 3.93104 2.02897 3.66324 2.1399C3.39544 2.25082 3.22083 2.51215 3.22083 2.80201V6.02701C3.22083 6.42283 3.5417 6.74368 3.9375 6.74368H7.1625C7.45236 6.74368 7.71369 6.56906 7.82463 6.30128C7.93553 6.03346 7.87422 5.72522 7.66925 5.52026Z"
            fill={fillColor}
        />
    </svg>
);

RecentIcon.propTypes = {
    fillColor: string,
};

RecentIcon.defaultProps = {
    fillColor: '#000000',
};

export default RecentIcon;
